import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=b44c07b0&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=b44c07b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44c07b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b44c07b0')) {
      api.createRecord('b44c07b0', component.options)
    } else {
      api.reload('b44c07b0', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=b44c07b0&scoped=true&", function () {
      api.rerender('b44c07b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4bHD2y2JfW43P/JS/comp/SearchFilterTokens.vue"
export default component.exports